import isPlainObject from './isPlainObject';
import flattenWhenNode from './flattenWhenNode';

export default flattenWhenNode(isPlainObject);


//////////////////
// WEBPACK FOOTER
// ./~/redux-actions/es/utils/flattenActionMap.js
// module id = 2756
// module chunks = 0